(function () {
  'use strict';
  angular
    .module('garanteasyApp')
    .factory('IcecatSimpleProduct', IcecatSimpleProduct);

  IcecatSimpleProduct.$inject = ['$resource', 'API_URI'];

  function IcecatSimpleProduct($resource, API_URI) {
    var resourceUrl = API_URI + 'api/ice-products/:id';

    return $resource(resourceUrl, {}, {
      'query': {method: 'GET', isArray: true},
      'get': {
        method: 'GET',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'update': {method: 'PUT'}
    });
  }
})();
